module.exports = __webpack_public_path__ + "static/media/careersPro_logo_grey.6001abac.svg";